import {ROLES} from './constants';

export const FULL_ACCESS_ROLES = [ROLES.ROLE_ADMIN, ROLES.ROLE_VNII, ROLES.ROLE_MINTRUD];

export const REGIONAL_ROLES = [
    ROLES.ROLE_REGIONAL_AGENCY,
    ROLES.ROLE_REGIONAL_ADMINISTRATOR,
    ROLES.ROLE_CZN_MANAGER,
];

export const TERRITORIAL_ROLES = [ROLES.ROLE_CZN_TERRITORIAL];

export const FEDERAL_VIEW_ROLES = [
    ...FULL_ACCESS_ROLES,
    ...REGIONAL_ROLES,
];

export const REGIONAL_VIEW_ROLES = [
    ...FULL_ACCESS_ROLES,
    ...REGIONAL_ROLES,
    ...TERRITORIAL_ROLES,
];
